import { combineReducers } from "redux";
//persist
//All reducers
import eventsReducer from "./Events/EventsReducer";

const rootReducer = combineReducers({
  events: eventsReducer
});
export default rootReducer;
